function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Listings",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Results",
  transform: "translate(-637.000000, -209.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Content",
  transform: "translate(280.000000, 90.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Results",
  transform: "translate(0.000000, 55.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6"
}, /*#__PURE__*/React.createElement("g", {
  id: 1
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(12.000000, 15.307692)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(345.000000, 48.692308)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-5",
  fill: "#F4F6F8",
  x: 0,
  y: 0,
  width: 22,
  height: 22,
  rx: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,10 L15,10 C15.5522847,10 16,10.4477153 16,11 C16,11.5522847 15.5522847,12 15,12 L12,12 L12,15 C12,15.5522847 11.5522847,16 11,16 C10.4477153,16 10,15.5522847 10,15 L10,12 L7,12 C6.44771525,12 6,11.5522847 6,11 C6,10.4477153 6.44771525,10 7,10 L10,10 L10,7 C10,6.44771525 10.4477153,6 11,6 C11.5522847,6 12,6.44771525 12,7 L12,10 Z",
  id: "Combined-Shape",
  fill: "#AAAFC4"
})))))))));

var SvgPlusBoxFilled = function SvgPlusBoxFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlusBoxFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PlusBoxFilled.930c192d.svg";
export { ForwardRef as ReactComponent };